// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MGtJJFOu2Lsu6Q6rWi1m {
  height: 100%;
  padding: 0 15px;
}
.dVPuQex6gT91AjdilsQm,
.Quv4qDzfue795K9X_Xbu {
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}
.dVPuQex6gT91AjdilsQm {
  position: relative;
}
.tPhCVQN6OXBpsim36xh1 {
  color: #fff;
  background-color: #037C4B;
  padding-right: 30px;
}
.Trmf7s5tW8f3ALzbdM8p {
  position: absolute;
  right: 7px;
  top: -4px;
}
.ZTMXQ4a10HYrs8x4yFFV {
  background-color: #fff;
  max-width: 800px;
  overflow-y: scroll;
}
.R07DQsoN3Sa_ncGnleuA {
  width: 260px;
  height: 200px;
  background-color: #F2F4F9;
  padding: 10px;
}
.SzxkmsJUa0aaNQfkSJKY {
  width: 100%;
  height: 180px;
  margin: 0 auto;
  background-color: #fff;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/Footer/index.module.less"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,eAAA;AAAF;AAGA;;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AAAF;AAGA;EACE,kBAAA;AADF;AAIA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AAFF;AAKA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAHF;AAMA;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;AAJF;AAOA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;AALF;AAQA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AANF","sourcesContent":["\n.container {\n  height: 100%;\n  padding: 0 15px;\n}\n\n.sheet, .addSheet {\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.sheet {\n  position: relative;\n}\n\n.activeSheet {\n  color: #fff;\n  background-color:#037C4B;\n  padding-right: 30px;\n}\n\n.moreAction {\n  position: absolute;\n  right: 7px;\n  top: -4px;\n}\n\n.sheetsContainer {\n  background-color: #fff;\n  max-width: 800px;\n  overflow-y: scroll;\n}\n\n.sheetImgBox {\n  width: 260px;\n  height: 200px;\n  background-color: #F2F4F9;\n  padding: 10px;\n}\n\n.sheetImg {\n  width: 100%;\n  height: 180px;\n  margin: 0 auto;\n  background-color: #fff;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MGtJJFOu2Lsu6Q6rWi1m`,
	"sheet": `dVPuQex6gT91AjdilsQm`,
	"addSheet": `Quv4qDzfue795K9X_Xbu`,
	"activeSheet": `tPhCVQN6OXBpsim36xh1`,
	"moreAction": `Trmf7s5tW8f3ALzbdM8p`,
	"sheetsContainer": `ZTMXQ4a10HYrs8x4yFFV`,
	"sheetImgBox": `R07DQsoN3Sa_ncGnleuA`,
	"sheetImg": `SzxkmsJUa0aaNQfkSJKY`
};
export default ___CSS_LOADER_EXPORT___;
